import React from "react";
import StatusPill from "./StatusPill";
import styles from "./systemHealth.module.css";

type ServiceTileProps = {
  name: string;
  status?: string;
  latencyMs?: number;
  error?: string;
};

const ServiceTile: React.FC<ServiceTileProps> = ({
  name,
  status,
  latencyMs,
  error,
}) => {
  return (
    <div className={styles.serviceTile}>
      <div className={styles.serviceTileTop}>
        <span className={styles.serviceTileName}>{name}</span>
      </div>
      <div className={styles.serviceTileBottom}>
        <StatusPill status={status} />
        {latencyMs != null && (
          <span className={styles.latencyBadge}>{latencyMs} ms</span>
        )}
      </div>
      {error && <div className={styles.serviceTileError}>{error}</div>}
    </div>
  );
};

export default ServiceTile;
